import FormLayout from './FormLayout';
import CustomButton from "./CustomButton";
import Box from '@mui/material/Box';

const ErrorFallback = ({ error, resetErrorBoundary }: any) => {
    // Note that we could output error.message when env is dev/testing
    return (
        <FormLayout
          title={`Whoops!`}
          subtitle={"Error"}
            description={"An unexpected error occurred"}
        >
            <Box component="div" mt={2}>
                <CustomButton
                  variant="contained"
                  label="Back"
                  onClick={() => resetErrorBoundary()}
                 />
            </Box>
        </FormLayout>
    )
}

export default ErrorFallback;
